'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = buildArticleQBURL;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _lodash = require('lodash');

var _buildArticleUrl = require('./buildArticleUrl');

var _buildArticleUrl2 = _interopRequireDefault(_buildArticleUrl);

var _buildAttachUrl = require('./buildAttachUrl');

var _buildAttachUrl2 = _interopRequireDefault(_buildAttachUrl);

var _QbUrlType = require('./QbUrlType');

var _qbBizIdMap = require('./qbBizIdMap');

var _qbBizIdMap2 = _interopRequireDefault(_qbBizIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                              * @Author: edconstdchen
                                                                                                                                                                                                                              * @Date:   2016-08-15 19:36:43
                                                                                                                                                                                                                              * @Last Modified by: jerryfwang
                                                                                                                                                                                                                              * @Last Modified time: 2020-09-23 12:06:36
                                                                                                                                                                                                                              */


/**
 * build QB url of article
 * 微信热文webview1是原网址
 * @param  {Object}  data
 * @param  {Boolean} data.immediate      是否显式添加contenturl和attachurl, 默认true
 * @param  {String}  data.business       业务名称
 * @param  {String}  data.docId
 * @param  {String}  data.url
 * @param  {Boolean} [data.single]       single-webview
 * @param  {Boolean} [data.showOriginal] contenturl是否使用原网址
 * @param  {String}  [data.tagId]
 * @param  {String}  [data.ch]
 * @param  {String}  [data.root] // 路由参数可以从上层传过来
 * @param  {Object}  [data.ext] // qb地址后面追加参数
 * @return {String}
 */
function buildArticleQBURL(_ref) {
  var docId = _ref.docId,
      url = _ref.url,
      tagId = _ref.tagId,
      ch = _ref.ch,
      business = _ref.business,
      showOriginal = _ref.showOriginal,
      immediate = _ref.immediate,
      single = _ref.single,
      _ref$ext = _ref.ext,
      ext = _ref$ext === undefined ? {} : _ref$ext,
      rest = _objectWithoutProperties(_ref, ['docId', 'url', 'tagId', 'ch', 'business', 'showOriginal', 'immediate', 'single', 'ext']);

  var base = 'qb://ext/read?cid=' + (tagId || '') + '&'; // 终端解析必须有?cid=
  var params = {
    type: 0,
    mttsummaryid: docId,
    b_f: ch,
    bizid: _qbBizIdMap2.default[business]
  };

  var data = _extends({
    tagId: tagId,
    docId: docId,
    ch: ch,
    business: business,
    url: url
  }, rest);

  if (immediate !== false) {
    if (showOriginal) {
      Object.assign(params, {
        contenturl: url,
        attachurl: (0, _buildAttachUrl2.default)(data)
      });
    } else {
      if (single) {
        data.showAttach = true;
        params.type = _QbUrlType.ARTICLE_SINGLE;
      }
      Object.assign(params, {
        contenturl: (0, _buildArticleUrl2.default)(data),
        attachurl: single ? '' : (0, _buildAttachUrl2.default)(data)
      });
    }
  }
  var _ext = (0, _lodash.isEmpty)(ext) ? '' : '&' + _queryString2.default.stringify(ext);
  return base + _queryString2.default.stringify(params) + _ext;
}